import React  from "react";
import {Card, Tab, Tabs} from "react-bootstrap";
import ManualBet1 from './includes/ManualBet1';
import AutoBet from './includes/AutoBet';
import {isMobile} from "../../../Helper";

class Bet1 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            bet: 'manual'
        };
    }

    componentDidMount() {
        if(isMobile()){
            this.setState({ padding: 'p-1', margin: 'mt-1' })
        }
    }

    render() {
        let { padding, margin } = this.state;
        let { token, isLogged, mobile ,bid,color,odd } = this.props;
        return (
                    <Tabs defaultActiveKey="manual" transition={false} id="crash-tabs" className={'tcr ml-1 mt-1 mb-2 ' + margin}>
                        <Tab eventKey="manual" title="Manual" tabClassName={'btn bg-cs2 btn-xs'}>
                            <ManualBet1 token={token} mobile={mobile} isLogged={isLogged} bid={bid} color={color} odd={odd} />
                        </Tab>
                        <Tab eventKey="auto" title="Auto" tabClassName={'btn bg-cs2 btn-xs'}>
                            <AutoBet isLogged={isLogged}/>
                        </Tab>
                    </Tabs>
        );
    }
}

export default Bet1;